//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';

export interface ParamsType {
    event_id: number;
    requestBody: {
        active?: null | undefined | boolean;
        antePost?: null | undefined | boolean;
        autoTakeDown?: null | undefined | boolean;
        display?: null | undefined | boolean;
        feedSettings?:
            | null
            | undefined
            | {
                  eachWay?: null | undefined | boolean;
                  prices?: null | undefined | boolean;
                  results?: null | undefined | boolean;
                  updates?: null | undefined | boolean;
              };
        grades?:
            | null
            | undefined
            | {
                  inPlay?:
                      | null
                      | undefined
                      | {
                            id: number;
                        };
                  prematch?:
                      | null
                      | undefined
                      | {
                            id: number;
                        };
                  show?:
                      | null
                      | undefined
                      | {
                            id: number;
                        };
              };
        inPlaySettings?:
            | null
            | undefined
            | {
                  betDelay?: null | undefined | number;
                  tradedInPlay?: null | undefined | boolean;
              };
        markets?:
            | null
            | undefined
            | Array<{
                  betDelay: number;
                  marketId: string;
                  tradedInPlay: boolean;
              }>;
        name?: null | undefined | string;
        tags?: null | undefined | Record<string, Array<string>>;
        timeSettings?:
            | null
            | undefined
            | {
                  offAtStartTime?: null | undefined | boolean;
                  startTime?: null | undefined | string;
                  timeZone?: null | undefined | string;
                  timeline?: null | undefined | string;
                  tradedInPlay?: null | undefined | boolean;
              };
    };
}

const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api-proxy/staff/events/{event_id} -> patch -> ${code}`);
    };
};

export const Response200IO = t.interface({
    code: t.number,
    message: t.string,
    status: t.string,
});
export type Response200Type = {
    code: number;
    message: string;
    status: string;
};
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.string;
export type Response400Type = string;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.string;
export type Response401Type = string;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response500IO = t.string;
export type Response500Type = string;
export const decodeResponse500 = createGuard(500, Response500IO);

type ExtraHeadersType = Record<string, string>;

/**
 * @deprecated - Please use this method "openapiProxyUpdateEventRequest"
 */
export const openapi_proxy_update_event = async (
    api_url: string,
    api_timeout: number,
    backendToken: string,
    params: ParamsType,
    extraHeaders?: ExtraHeadersType
): Promise<FetchGeneralRawResponseType> => {
    const query = '';
    const url = `${api_url}/api-proxy/staff/events/${params.event_id}${query}`;

    const method = 'PATCH';
    const paramsFetch = {
        url,
        body: params.requestBody,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};

export type OpenapiProxyUpdateEventParamsType = ParamsType;

export type OpenapiProxyUpdateEventResponseType =
    | {
          status: 200;
          body: Response200Type;
      }
    | {
          status: 400;
          body: Response400Type;
      }
    | {
          status: 401;
          body: Response401Type;
      }
    | {
          status: 500;
          body: Response500Type;
      };

export type OpenapiProxyUpdateEventResponse200Type = Response200Type;

export const openapiProxyUpdateEventRequest = async (
    api_url: string,
    api_timeout: number,
    backendToken: string,
    params: ParamsType,
    extraHeaders?: ExtraHeadersType
): Promise<OpenapiProxyUpdateEventResponseType> => {
    const response = await openapi_proxy_update_event(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }

    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiProxyUpdateEventRequest - unhandled response ${response.status}`);
};
